import { create } from 'zustand';
import axios from 'axios';
import i18n from '../i18n';

const API_URL =
  process.env.REACT_APP_API_URL || "https://api.masaje-tantrico.es";

export const useAuthStore = create((set, get) => ({
  user: null,
  token: localStorage.getItem('token'),
  isLoading: true,
  isAuthenticated: false,

  login: async (email, password) => {
    const response = await axios.post(`${API_URL}/api/auth/login`, { email, password });
    const { token, user } = response.data;
    localStorage.setItem('token', token);
    // Set language from user preference
    if (user.preferred_language) {
      i18n.changeLanguage(user.preferred_language);
      localStorage.setItem('language', user.preferred_language);
    }
    set({ token, user, isAuthenticated: true, isLoading: false });
    return user;
  },

  register: async (email, password, name, language = 'es') => {
    const response = await axios.post(`${API_URL}/api/auth/register`, {
      email,
      password,
      name,
      preferred_language: language,
    });
    const { token, user } = response.data;
    localStorage.setItem('token', token);
    // Set language from registration choice
    i18n.changeLanguage(language);
    localStorage.setItem('language', language);
    set({ token, user, isAuthenticated: true, isLoading: false });
    return user;
  },

  logout: () => {
    localStorage.removeItem('token');
    set({ user: null, token: null, isAuthenticated: false });
  },

  loadUser: async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      set({ isLoading: false });
      return;
    }
    try {
      const response = await axios.get(`${API_URL}/api/auth/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const user = response.data;
      // Set language from user preference on page reload
      if (user.preferred_language) {
        i18n.changeLanguage(user.preferred_language);
        localStorage.setItem('language', user.preferred_language);
      }
      set({ user, token, isAuthenticated: true, isLoading: false });
    } catch (error) {
      localStorage.removeItem('token');
      set({ user: null, token: null, isAuthenticated: false, isLoading: false });
    }
  },

  updateUser: async (data) => {
    const { token } = get();
    const response = await axios.put(`${API_URL}/api/auth/me`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    set({ user: response.data });
    return response.data;
  },

  getAuthHeaders: () => {
    const { token } = get();
    return token ? { Authorization: `Bearer ${token}` } : {};
  },
}));
